import { mergeWith, cloneDeep } from 'lodash'

export const mergeNotNull = (originalObj, updatedObj) =>
  mergeWith(cloneDeep(originalObj), updatedObj, (objValue, srcValue) => {
    if (srcValue === null) {
      return objValue
    }
  })
